import React from "react";

import { FilterSingleSelect } from "@/components/common/FilterSingleSelect";
import { useRoomCategoriesFiltersSettings } from "@/hooks/useRoomCategories";
import { RoomFilters, RoomStatus } from "@/types/room";

const RoomCategoriesFilter = ({
  filters,
  actions,
  hotelId,
}: {
  hotelId: string;
  filters: RoomFilters;
  actions: {
    setStatus: (value: string) => void;
    setCategory: (value: string) => void;
    handleFilterChange: (
      setter: (value: string) => void,
      value: string,
    ) => void;
  };
}) => {
  const { data: settings, isPending } =
    useRoomCategoriesFiltersSettings(hotelId);

  if (isPending) {
    return null;
  }

  return (
    <>
      <FilterSingleSelect
        value={filters.status || "all statuses"}
        placeholder="All Status"
        className="min-w-[140px] justify-between"
        options={[
          { value: "all statuses", label: "All Status" },
          { value: RoomStatus.AVAILABLE, label: "Free" },
          { value: RoomStatus.OUT_OF_SERVICE, label: "Unavailable" },
          { value: RoomStatus.OCCUPIED, label: "Occupied" },
        ]}
        onValueChange={(value: string) =>
          actions.handleFilterChange(actions.setStatus, value)
        }
      />

      <FilterSingleSelect
        value={filters.categoryId}
        placeholder="Categories"
        className="min-w-[140px] justify-between"
        options={[
          { value: "all categories", label: "Categories" },
          ...(settings?.categories.map((category) => ({
            value: category.id,
            label: category.name,
          })) || []),
        ]}
        onValueChange={(value) =>
          actions.handleFilterChange(actions.setCategory, value)
        }
      />
    </>
  );
};

export default RoomCategoriesFilter;
